import CountdownComponent from './Countdown';
import StatisticComponent from './Statistic';

type StatisticComponentType = typeof StatisticComponent;

interface StatisticInterface extends StatisticComponentType {
  Countdown: typeof CountdownComponent;
}

const Statistic: StatisticInterface = Object.assign(StatisticComponent, { Countdown: CountdownComponent });

export default Statistic;
